<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
                <add-button v-if="$_createActionAllowed" :title="'Přidat službu' | translate" route-name="serviceNew"></add-button>
                <h1 v-translate>Služby</h1>
            </div>
            <div class="inner_white">
                <div class="filter">
                    <div class="field_left">
                        <search-input input-class="search" v-model="formFields.search"></search-input>
                    </div>
                  <div class="field_right">
                    <p class="field checkbox_label" v-translate>Rozšířené vyhledávání</p>
                    <div class="field checkboxes">
                      <filter-checkbox
                          key="search_in_channels"
                          id="search_in_channels"
                          name="search_in_channels"
                          v-model="formFields.search_in_channels">
                        <translate class="translate">Hledat v názvech kanálů</translate>
                      </filter-checkbox>
                    </div>
                  </div>
                  <div class="field_left" v-if="showOperatorFilter">
                    <select-box
                        id="operatorselect"
                        :options="operatorOptions"
                        v-model="formFields.operator"
                        ref="operatorselectref"
                    >
                      <translate class="translate">Operátor</translate>
                    </select-box>
                  </div>
                  <div class="field_right" v-if="$_loggedUser_action_allowed('businessModels')">
                    <select-box
                        id="businessmodelselect"
                        :options="businessModelOptions"
                        v-model="formFields.businessModel"
                        ref="businessmodelselectref"
                    >
                      <translate class="translate">Business model</translate>
                    </select-box>
                  </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
                <form>
                    <div class="table_overflow">
                      <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                        <thead>
                        <tr>
                            <th class="no_padding drag_drop"></th>
                            <th class="no_padding checkbox"></th>
                            <sorting-table-title
                                    v-for="title in sortingTableTitles"
                                    :key="title.id"
                                    :column="title.column"
                                    :sort="getActiveSort(title.column)"
                                    @changeSorting="changeSorting"
                            >{{ title.name }}
                            </sorting-table-title>
                            <th class="no_padding edit"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <service-row
                                v-for="entity in entities"
                                :entity="entity"
                                :key="entity.id"
                                :selectedEntities="selectedEntities"
                                @input="select"
                                ref="service_row"
                                @updateEntity="updateEntity"
                                @deleteEntity="deleteEntity"
                        ></service-row>
                        </tbody>
                    </table>
                    </div>

                    <list-action-line
                            :entities="entities"
                            :selected-entities="filteredSelectedEntities"
                            :multiple-action-options="multipleActionOptions"
                            :offset="formFields.offset"
                            :limit="formFields.limit"
                            :total-count="totalCount"
                            @select-all="toggleSelectAll"
                            @run-multiple-action="runMultipleActionWithKey"
                            @limit="setLimit"
                            @offset="setOffset"
                            ref="action_line"
                    ></list-action-line>
                </form>
            </div>
        </form>
    </div>
</template>

<script>
	import ServiceRow from "@/components/views/services/ServiceRow"
	import listActions from "@/components/mixins/list-actions"
  import {prependOptions} from "@/utils/helpers"

	export default {
		name: "ServiceList",
		components: {ServiceRow},
		mixins: [listActions],
		data() {
			return {
				formFields: {
					sort: {
						column: 'sName',
						direction: 'asc',
					},
          businessModel: null,
          operator: 0,
          search_in_channels: false,
				},
				moduleName: 'services',
        businessModels: [],
        operators: [],
			}
		},
		created(ServiceService, BusinessModelService, OperatorService) {
			this.entityService = ServiceService
      this.businessModelService = BusinessModelService
      this.operatorService = OperatorService;
      if(this.$_loggedUser_action_allowed('businessModels')) {
        this.businessModelService.getEntities()
            .then((data) => {
              this.businessModels = [{'id': null, 'name': this.$gettext('Všechny')}, ...data['business_models']];
            })
            .catch(error => {
              this.setErrorMessage(error['error_message'])
            })
      }

      if(this.$_loggedUser_canChangeOperator) {
        this.loadOperators();
      }
			this.createdInit()
		},
		computed: {
			sortingTableTitlesOperator() {
				return [
					{id: 1, name: this.$gettext('Název'), column: 'sName'},
					{id: 2, name: this.$gettext('Váha'), column: 'sWeight'},
					{id: 3, name: this.$gettext('Kanály'), column: 'sChannelsCount'},
					{id: 4, name: this.$gettext('PVR'), column: 'sPvrDays'},
					{id: 5, name: this.$gettext('Volné minuty'), column: 'sPvrFreeMinutes'},
					{id: 6, name: this.$gettext('Catchup'), column: 'sCatchupHours'},
					{id: 7, name: this.$gettext('Timeshift'), column: 'sTimeshift'},
          {id: 8, name: this.$gettext('Počet současně streamujících zařízení'), column: 'sDeviceCount'},
					{id: 9, name: this.$gettext('Platnost od'), column: 'sValidFrom'},
					{id: 10, name: this.$gettext('Platnost do'), column: 'sValidTo'},
				]
			},
			sortingTableTitlesOwner() {
				return [
					{id: 1, name: this.$gettext('Název'), column: 'sName'},
					{id: 2, name: this.$gettext('Operátor'), column: 'sOperator'},
					{id: 3, name: this.$gettext('Business model'), column: 'sBusinessModel'},
					{id: 4, name: this.$gettext('Váha'), column: 'sWeight'},
					{id: 5, name: this.$gettext('Kanály'), column: 'sChannelsCount'},
					{id: 6, name: this.$gettext('PVR'), column: 'sPvrDays'},
					{id: 7, name: this.$gettext('Volné minuty'), column: 'sPvrFreeMinutes'},
					{id: 8, name: this.$gettext('Catchup'), column: 'sCatchupHours'},
					{id: 9, name: this.$gettext('Timeshift'), column: 'sTimeshift'},
          {id: 10, name: this.$gettext('Počet současně streamujících zařízení'), column: 'sDeviceCount'},
					{id: 11, name: this.$gettext('Platnost od'), column: 'sValidFrom'},
					{id: 12, name: this.$gettext('Platnost do'), column: 'sValidTo'},
				]
			},
			sortingTableTitles() {
				if (this.$_readActionAllowedAllOrOwnAndGlobal) {
					return this.sortingTableTitlesOwner
				} else {
					return this.sortingTableTitlesOperator
				}
			},
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
        if(headers.hasOwnProperty("operator")){
          headers.operator.callback = entity => {return entity.operator_name};
        }
        if(headers.hasOwnProperty("business_model")){
          headers.business_model.callback = entity => {return entity.business_model_name};
        }
        headers.weight.callback = (entity) => {return entity.weight > 0 ? entity.weight : '' };
        headers.channels_count.callback = (entity) => {return entity.channels_count > 0 ? entity.channels_count : '' };
        headers.pvr_days.callback = (entity, index) => {return this.$refs.service_row[index].pvrDays() };
        headers.pvr_free_minutes.callback = (entity, index) => {return this.$refs.service_row[index].pvrMinutes() };
        headers.catchup_hours.callback = (entity, index) => {return this.$refs.service_row[index].catchup() };
        headers.timeshift.callback = (entity, index) => {return this.$refs.service_row[index].timeshift() };
        headers.device_count.callback = (entity, index) => {return this.$refs.service_row[index].deviceCount() };

        return headers;
      },
      businessModelOptions() {
        if (this.businessModels) {
          return this._.map(this.businessModels, function (item) {
            return {id: item['id'], text: item['name']}
          });
        } else {
          return []
        }
      },
      operatorOptions() {
        if (this.operators) {
          let data = this._.map(this.operators, function (item) {
            return {id: item['id'], text: item['name']}
          });
          data.unshift({'id': 'global', 'text':this.$gettext('Pouze globální')});
          data.unshift({'id': 0, 'text':this.$gettext('Všechny')});
          return [...data];
        } else {
          return []
        }
      },
      showOperatorFilter(){
        return this.$_loggedUser_action_allowed('operators') && this.$_loggedUser_canChangeOperator && this.getOwnerSettingByKey('selected-operator-id') == null;
      },
		},
		methods: {
      loadOperators(){
        this.operatorService.getOperators({id_business_model: this.formFields.businessModel})
            .then((data) => {
              this.operators = data['operators']
            })
            .catch(error => {
              this.setErrorMessage(error['error_message'])
            })
      },
			runMultipleActionWithKey(action) {
				this.runMultipleAction(action, 'enabled')
			},
			loadAdditionalDefaults() {
				let anyChanges = false
        if (this.loadDefaultByKey('businessModel') && this.formFields.businessModel !== 0) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('operator') && this.formFields.operator !== 0) {
          anyChanges = true
        }
        if (this.loadDefaultByKey('search_in_channels') && this.formFields.search_in_channels !== 0) {
          anyChanges = true
        }
				return anyChanges
			},
			saveFilterValues() {
				this.saveSearch(this.formFields.search)
        this.setUserSetting('businessModel', this.formFields.businessModel)
        this.setUserSetting('operator', this.formFields.operator)
        this.setUserSetting('search_in_channels', this.formFields.search_in_channels)
			},
			_processListErrorMessage(error) {
				this._.forEach(error['validation_errors'], function (errorMessage) {
					if (this._.includes(errorMessage, 'Unable to delete service') &&
						this._.includes(errorMessage, 'subscribers with given service')) {
						error['error_message'] = this.$gettext('Službu není možné smazat - je přiřazená odběratelům.')
					}
				}.bind(this))

				return error['error_message']
			}
		},
    watch: {
      "formFields.businessModel"(){
        this.formFields.operator = 0;
        this.loadOperators();
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/services/ServiceList.vue